import _isEmpty from 'lodash/isEmpty';

export const getPromoEligibleProducts = (allProducts) => {
  let productsWithPromos = {};

  Object.keys(allProducts).forEach((sku) => {
    const promotionId = allProducts[sku].pricing?.conditionalPromotions?.[0]?.promotionId;
    if (promotionId) {
      const promotionTags = allProducts[sku].pricing?.conditionalPromotions[0]?.promotionTags;
      productsWithPromos[sku] = {
        promotionId,
        promotionTags
      };
    }
  });

  return productsWithPromos;
};

export const getProductPromoDetails = (sku, allPromoProducts, enabledPromoTypes) => {

  const promoProduct = allPromoProducts[sku];

  if (_isEmpty(promoProduct?.promotionTags)
    || _isEmpty(enabledPromoTypes)
    || promoProduct?.promotionTags[0] !== enabledPromoTypes[0]) {
    return null;
  }

  return promoProduct;
};

export const getPromoEligibleItemsInDesign = (design, allPromoProducts, enabledPromoTypes) => {

  let promoItemsInDesign = {};
  const itemsInDesign = [...design.cart, ...design.products];

  if (_isEmpty(itemsInDesign)) {
    return promoItemsInDesign;
  }

  const itemMap = new Map();
  Object.values(itemsInDesign).forEach((itemInDesign) => {
    const itemId = String(itemInDesign.Sku);
    const quantity = itemInDesign.Quantity || 1;
    if (itemMap.has(itemId)) {
      itemMap.get(itemId).quantity += quantity;
    } else {
      const promoDetails = getProductPromoDetails(itemId, allPromoProducts, enabledPromoTypes);
      if (promoDetails) {
        itemMap.set(itemId, { itemId, quantity, promotionId: promoDetails.promotionId });
      }
    }
  });

  itemMap.forEach((item) => {
    if (!promoItemsInDesign[item.promotionId]) {
      promoItemsInDesign[item.promotionId] = [];
    }
    promoItemsInDesign[item.promotionId].push(item);
  });

  return promoItemsInDesign;
};
